import { __decorate } from "tslib";
import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import NameAndStatus from '@blade-sxp/task-management/components/name-status.vue';
import DeviceDarwer from '@blade-sxp/task-management/components/deviceDarwer/index.vue';
import AlarmMode from '@blade-sxp/task-management/components/alarm-mode.vue';
import AlarmLevel from '@blade-sxp/task-management/components/alarm-level.vue';
import FrequencyAndThreshold from '@blade-sxp/task-management/components/frequency-threshold.vue';
import SingleConfidence from '@blade-sxp/task-management/components/single-confidence.vue';
import ButtonBox from '@blade-sxp/task-management/components/button-box.vue';
import ValidTime from '@blade-sxp/task-management/components/valid-time1.vue';
import TargetSize from '@blade-sxp/task-management/components/target-size.vue';
import ComparisonCategories from '@blade-sxp/task-management/components/comparison-categories.vue';
import { plotMap } from '@blade-sxp/task-management/components/deviceDarwer/plotConfig';
import { DeviceIdDataModule } from '@blade-sxp/task-management/store/deviceIdData';
import { isEmpty, cloneDeep } from 'lodash';
import { getTaskDetail, postTask, updateTask } from '@blade-sxp/task-management/api/creat-task/index';
import TaskNote from '@blade-sxp/task-management/components/task-note.vue';
let AlalysisEverything = class AlalysisEverything extends Vue {
    loading = false;
    name = '';
    status = 'ENABLE';
    isDetail = false;
    taskType = 'EVERYTHING_DETECT';
    isReady = false;
    mode = 'MATCHED';
    isDetailMode = false;
    threshold = NaN;
    isError = false;
    effectivePeriod = 'PERMANENT';
    effectiveDates = {
        start: '',
        end: '',
    };
    id = '';
    effectiveTimes = [{ start: '', end: '' }];
    dayOfWeeks = [];
    confidenceValue = '66';
    disableRight = false;
    type = 'add';
    level = 'CRITICAL';
    comparisonText = '';
    comparisonImg = '';
    imageTargetLeft = '40000';
    imageTargetRight = '700000';
    alarmSuppression;
    httpUrl;
    everyDetectThreshold = {};
    remark = '';
    get formData() {
        const { name, effectivePeriod, effectiveDates, effectiveTimes, dayOfWeeks, isReady, confidenceValue, comparisonText, comparisonImg } = this;
        return {
            name,
            effectivePeriod,
            effectiveDates,
            effectiveTimes,
            dayOfWeeks,
            isReady,
            confidenceValue,
            comparisonText,
            comparisonImg,
        };
    }
    init() {
        this.clearData();
        const { type, id, taskType } = this.$route.query;
        if (!type) {
            this.$message.error(`${this.$t('common.unknownError')}`);
        }
        this.type = type;
        this.id = id;
        this.taskType = taskType;
        if (type === 'detail' || type === 'update') {
            this.isDetailMode = true;
        }
        else {
            this.isDetailMode = false;
        }
        this.isDetail = type === 'detail';
        if (this.type === 'add') {
            this.loading = false;
        }
        else {
            if (this.isDetail) {
                this.disableRight = false;
            }
            this.getData();
        }
    }
    async validForm() {
        if (this.isDetail) {
            return;
        }
        if (!this.isReady) {
            this.disableRight = true;
            return;
        }
        for (let i = 1; i <= 7; i++) {
            if (this.$refs['formItem' + i]) {
                let res = await this.$refs['formItem' + i].isValidate();
                if (!res) {
                    this.disableRight = true;
                    return;
                }
            }
        }
        this.disableRight = false;
    }
    getData() {
        getTaskDetail(Number(this.id)).then(({ name, status, remark, alarmConfig: { thresholdConfigs, notifyConfig }, deviceTaskConfigs }) => {
            this.name = name;
            this.remark = remark;
            if (status === 'ERROR') {
                this.isError = true;
                this.status = 'ENABLE';
            }
            else {
                this.status = status;
            }
            if (notifyConfig) {
                this.httpUrl = notifyConfig.url;
                this.alarmSuppression = notifyConfig?.frequency?.value;
            }
            if (thresholdConfigs) {
                const { dayOfWeeks, effectiveDates, effectivePeriod, effectiveTimes, levelConfig, everyDetectThreshold, structDetectThreshold } = thresholdConfigs[0];
                this.dayOfWeeks = dayOfWeeks;
                this.effectivePeriod = effectivePeriod;
                if (this.effectivePeriod !== 'PERMANENT') {
                    this.effectiveDates = effectiveDates[0];
                    this.effectiveTimes = effectiveTimes.map((item) => {
                        return { ...item, effectiveTimes: [item.start, item.end] };
                    });
                }
                for (let key in levelConfig) {
                    if (levelConfig[key]) {
                        this.threshold = levelConfig[key];
                        this.level = key.toUpperCase();
                    }
                }
                if (everyDetectThreshold) {
                    const { base64Image, everyTargetConfidence, keyText, targetDetectRange, alertTypeEnum } = everyDetectThreshold;
                    this.comparisonImg = base64Image;
                    this.confidenceValue = everyTargetConfidence.value;
                    this.comparisonText = keyText;
                    this.imageTargetLeft = targetDetectRange.left;
                    this.imageTargetRight = targetDetectRange.right;
                    this.mode = alertTypeEnum;
                }
            }
            if (!isEmpty(deviceTaskConfigs)) {
                deviceTaskConfigs.forEach((item) => {
                    const roiData = item.roiData;
                    if (!isEmpty(roiData)) {
                        const analysis = JSON.parse(roiData);
                        DeviceIdDataModule.deviceIdRequestParams.set(item.deviceId, analysis);
                    }
                    // DeviceIdDataModule?.deviceIdRequestParams.set(item.deviceId, { zoneId: item.zoneId, deviceId: item.deviceId });
                });
            }
            // this.portraitId = this.formatPortraitToForm(deviceTaskConfigs);
            this.loading = false;
        });
    }
    clearData() {
        this.loading = true;
        this.isDetail = false;
        this.isReady = false;
        this.isError = false;
        this.disableRight = true;
        this.id = '';
        this.type = 'add';
        this.taskType = 'FACE_ALERT';
        this.name = '';
        this.alarmSuppression = '';
        this.status = 'ENABLE';
        this.level = 'CRITICAL';
        this.threshold = NaN;
        this.effectivePeriod = 'PERMANENT';
        this.effectiveDates = {
            start: '',
            end: '',
        };
        this.effectiveTimes = [{ start: '', end: '' }];
        this.dayOfWeeks = [];
        this.comparisonText = '';
        this.comparisonImg = '';
    }
    confirm() {
        if (this.type === 'detail') {
            const url = this.$route.path;
            this.$router.push({ path: url, query: { type: 'update', taskType: this.taskType, id: this.id } });
            this.$route.meta.title = this.$route.meta.title.replace('look', 'edit');
        }
        else {
            this.submit();
        }
    }
    cancel() {
        if (this.type === 'detail') {
            this.$router.push('/tasklist');
        }
        else {
            this.$confirm(`${this.$t('cancelSubmitTip')}`, `${this.$t('tip')}`, {
                confirmButtonText: `${this.$t('confirm')}`,
                cancelButtonText: `${this.$t('cancel')}`,
                cancelButtonClass: 'cancel-roi-tip',
                confirmButtonClass: 'confirm-roi-tip',
                type: 'warning',
            })
                .then(() => {
                this.$router.push('/tasklist');
            })
                .catch(() => { });
        }
    }
    submit() {
        let taskStatus = '';
        if (this.type === 'update') {
            if (this.isError && this.status === 'DISABLE') {
                taskStatus = 'DISABLE';
            }
            else if (this.isError && this.status === 'ENABLE') {
                taskStatus = 'ERROR';
            }
            else {
                taskStatus = this.status;
            }
        }
        else {
            taskStatus = this.status;
        }
        const effectiveTimes = [];
        if (this.effectivePeriod === 'CUSTOMIZE') {
            this.effectiveTimes.forEach((item) => {
                effectiveTimes.push({ start: item.effectiveTimes[0], end: item.effectiveTimes[1] });
            });
        }
        this.everyDetectThreshold = {
            alertTypeEnum: this.mode,
            base64Image: this.comparisonImg,
            everyTargetConfidence: {
                countUnitEnum: 'PERCENT',
                value: Number(this.confidenceValue),
            },
            keyText: this.comparisonText,
            targetDetectRange: {
                left: Number(this.imageTargetLeft),
                right: Number(this.imageTargetRight),
            },
        };
        const req = {
            remark: this.remark,
            taskName: this.name,
            taskStatus: taskStatus,
            taskType: this.taskType,
            alarmConfig: {
                enable: true,
                notifyConfig: {
                    enabledAlarmLevels: [this.level],
                    frequency: {
                        unit: 'SECOND',
                        value: this.alarmSuppression,
                    },
                },
                thresholdConfigs: [
                    {
                        effectivePeriod: this.effectivePeriod,
                        dayOfWeeks: this.dayOfWeeks,
                        effectiveTimes: this.effectivePeriod === 'PERMANENT' ? [] : [...effectiveTimes],
                        effectiveDates: this.effectivePeriod === 'PERMANENT' ? [] : [this.effectiveDates],
                        levelConfig: {
                            [this.level.toLowerCase()]: this.alarmSuppression,
                            unit: 'PERCENT',
                        },
                        everyDetectThreshold: this.everyDetectThreshold,
                    },
                ],
            },
            deviceTaskConfigs: this.fromDataDeviceConfig(),
        };
        if (this.type === 'add' || this.type === 'copy') {
            postTask(req).then((res) => {
                this.$message.success(`${this.$t('common.success')}`);
                this.$router.push('/tasklist');
            });
        }
        else {
            updateTask({ taskId: this.id, ...req }).then((res) => {
                this.$message.success(`${this.$t('common.success')}`);
                this.$router.push('/tasklist');
            });
        }
    }
    taskId() {
        const num = Math.random() * 100000;
        return Math.round(num);
    }
    fromDataDeviceConfig() {
        const config = [];
        let device = DeviceIdDataModule.deviceIdRequestParams;
        let requestMap = new Map();
        requestMap = cloneDeep(device);
        const incidentType = plotMap.get(this.taskType).incidentType;
        if (!isEmpty(requestMap) && !isEmpty(incidentType)) {
            requestMap.forEach((item) => {
                const { zoneId, deviceId, titleList } = item;
                let rawRoi = [];
                if (!isEmpty(titleList)) {
                    titleList.forEach((item) => {
                        if (item.type === 'ROI') {
                            item.data.forEach((item) => {
                                const { vertices, id } = item;
                                vertices.shift();
                                rawRoi.push({
                                    rawRoi: {
                                        vertices,
                                        id: this.taskId(),
                                        name: id,
                                    },
                                });
                            });
                        }
                    });
                }
                let data = {
                    everyDetectConfig: {
                        roiMappings: rawRoi, // 绘制的roi
                    },
                    zoneId,
                    deviceId,
                    incidentType,
                    roiData: JSON.stringify(device.get(deviceId)),
                };
                config.push(data);
            });
        }
        return config;
    }
};
__decorate([
    Watch('$route', { immediate: true, deep: true })
], AlalysisEverything.prototype, "init", null);
__decorate([
    Watch('formData', { deep: true })
], AlalysisEverything.prototype, "validForm", null);
AlalysisEverything = __decorate([
    Component({
        name: 'alalysis-everything',
        components: {
            NameAndStatus,
            DeviceDarwer,
            AlarmMode,
            AlarmLevel,
            FrequencyAndThreshold,
            SingleConfidence,
            ButtonBox,
            ValidTime,
            TargetSize,
            ComparisonCategories,
            TaskNote,
        },
        i18n: {
            messages: {
                en: {
                    alert: 'Alert Notification',
                    cancelSubmitTip: 'Data will not be saved and exit. Are you sure to exit?',
                    tip: 'Tips',
                    confirm: 'Confirm',
                    cancel: 'Cancel',
                },
                zh: {
                    alert: '告警通知',
                    cancelSubmitTip: '数据将不会保存并退出，确定退出吗？',
                    tip: '提示',
                    confirm: '确定',
                    cancel: '取消',
                },
            },
        },
    })
], AlalysisEverything);
export default AlalysisEverything;
